<template>
  <section class="product-spec" :style="{ backgroundImage: `url(${specBackground})` }">
    <div class="spec-inner">
      <h2 v-html="$t('model')"></h2>
      <div class="table-scroller">
        <table class="spec-table">
          <thead>
            <tr>
              <th scope="col">Gauge</th>
              <th scope="col">Code</th>
              <th scope="col">Description</th>
              <th scope="col">Inch</th>
              <th scope="col">Thin wall</th>
              <th scope="col">Pcs/Box</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="group in groupedData" :key="group.gauge">
              <tr v-for="(item, index) in group.items" :key="item.code">
                <td v-if="index === 0" :rowspan="group.items.length" class="gauge-cell">
                  {{ group.gauge }}
                </td>
                <td>{{ item.code }}</td>
                <td>{{ item.description }}</td>
                <td v-html="formatInch(item.inch)"></td>
                <td>{{ item.thinWall }}</td>
                <td>{{ item.box }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <p class="legal-note" v-html="$t('TskSelectNeedle.description')"></p>
      <a
        class="catalogue-link"
        href="/Brochure/TSK_Select%20Needle.pdf"
        target="_blank"
        rel="noopener noreferrer"
      ><span>Download the catalogue</span></a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TskSelectNeedleProductSpec',
  data() {
    return {
      tableData: [
        { gauge: '34G', code: 'TSN-018002', description: '34G x 2mm', inch: '5/64"', thinWall: '√', box: '100' },
        { gauge: '34G', code: 'TSN-018004', description: '34G x 4mm', inch: '3/16"', thinWall: '√', box: '100' },
        { gauge: '34G', code: 'TSN-018009', description: '34G x 9mm', inch: '3/8"', thinWall: '√', box: '100' },
        { gauge: '33G', code: 'TSN-020002', description: '33G x 2mm', inch: '5/64"', thinWall: '√', box: '100' },
        { gauge: '33G', code: 'TSN-020004', description: '33G x 4mm', inch: '3/16"', thinWall: '√', box: '100' },
        { gauge: '33G', code: 'TSN-020009', description: '33G x 9mm', inch: '3/8"', thinWall: '√', box: '100' },
        { gauge: '33G', code: 'TSN-020013', description: '33G x 13mm', inch: '1/2"', thinWall: '√', box: '100' },
        { gauge: '32G', code: 'TSN-023002', description: '32G x 2mm', inch: '5/64"', thinWall: '√', box: '100' },
        { gauge: '32G', code: 'TSN-023004', description: '32G x 4mm', inch: '3/16"', thinWall: '√', box: '100' },
        { gauge: '32G', code: 'TSN-023009', description: '32G x 9mm', inch: '3/8"', thinWall: '√', box: '100' },
        { gauge: '32G', code: 'TSN-023013', description: '32G x 13mm', inch: '1/2"', thinWall: '√', box: '100' },
        { gauge: '31G', code: 'TSN-025004', description: '31G x 4mm', inch: '3/16"', thinWall: '√', box: '100' },
        { gauge: '31G', code: 'TSN-025009', description: '31G x 9mm', inch: '3/8"', thinWall: '√', box: '100' },
        { gauge: '31G', code: 'TSN-025013', description: '31G x 13mm', inch: '1/2"', thinWall: '√', box: '100' },
        { gauge: '30G', code: 'TSN-030002', description: '30G x 2mm', inch: '5/64"', thinWall: '√', box: '100' },
        { gauge: '30G', code: 'TSN-030004', description: '30G x 4mm', inch: '3/16"', thinWall: '√', box: '100' },
        { gauge: '30G', code: 'TSN-030009', description: '30G x 9mm', inch: '3/8"', thinWall: '√', box: '100' },
        { gauge: '30G', code: 'TSN-030013', description: '30G x 13mm', inch: '1/2"', thinWall: '√', box: '100' },
        { gauge: '30G', code: 'TSN-030013E', description: '30G x 13mm', inch: '1/2"', thinWall: '', box: '100' },
        { gauge: '30G', code: 'TSN-030025', description: '30G x 25mm', inch: '1"', thinWall: '√', box: '100' },
        { gauge: '27G', code: 'TSN-040013', description: '27G x 13mm', inch: '1/2"', thinWall: '', box: '100' },
        { gauge: '27G', code: 'TSN-040019R', description: '27G x 19mm', inch: '3/4"', thinWall: '', box: '100' },
        { gauge: '25G', code: 'TSN-050013', description: '25G x 13mm', inch: '1/2"', thinWall: '', box: '100' },
        { gauge: '25G', code: 'TSN-050025R', description: '25G x 25mm', inch: '1"', thinWall: '', box: '100' }
      ]
    }
  },
  computed: {
    specBackground() {
      return require('@/assets/images/AppShell/products/TSN/TSN_Available-sizes_bg.png')
    },
    groupedData() {
      return this.tableData.reduce((groups, item) => {
        const current = groups.find(group => group.gauge === item.gauge)
        if (current) current.items.push(item)
        else groups.push({ gauge: item.gauge, items: [item] })
        return groups
      }, [])
    }
  },
  methods: {
    /**
     * 將 "3/8\"" 格式轉換為分數排版 HTML
     * 分子上標 + Unicode 分數斜線 + 分母下標 + 英吋符號
     */
    formatInch(inch) {
      if (!inch) return ''
      // 比對分數格式，例如 "3/8\""、"3/16\""、"1/2\""
      const fracMatch = inch.match(/^(\d+)\/(\d+)("?)$/)
      if (fracMatch) {
        const [, num, den] = fracMatch
        return `<span class="frac"><sup>${num}</sup>\u2044<sub>${den}</sub></span>\u2033`
      }
      // 整數格式，例如 "1\""
      const intMatch = inch.match(/^(\d+)("?)$/)
      if (intMatch) {
        return `${intMatch[1]}\u2033`
      }
      return inch
    }
  }
}
</script>

<style scoped>
/* ── 規格區塊 ── */
.product-spec {
  padding: 4rem 0;
  background-color: #fff;
  background-position: center;
  background-size: cover;
}

.spec-inner {
  width: min(calc(100% - 3rem), 1120px);
  max-width: 1120px;
  margin: 0 auto;
}

.spec-inner > h2 {
  margin: 0 0 1rem;
  color: #5fa4b8;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.45;
  text-align: left;
}

/* ── 表格捲動容器 ── */
.table-scroller {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* ── 規格表（對齊 STERiGLIDE 模板）── */
.spec-table {
  width: 100%;
  min-width: 760px;
  border-collapse: separate;
  border-spacing: 0 5px;   /* 每行之間有 5px 白色間距 */
  color: #333;
  font-size: 16px;
}

.spec-table th,
.spec-table td {
  padding: 0.8rem;
  border-right: 1px solid #e2e2e2;
  text-align: center;
  vertical-align: middle;
}

/* thead 與 gauge-cell 同色 */
.spec-table thead th,
.gauge-cell {
  background: #5fa4b8;
  color: #fff;
  font-weight: 700;
}

/* 資料列：白底 + 上下邊框 */
.spec-table tbody td:not(.gauge-cell) {
  border-top: 1px solid #dfe3e6;
  border-bottom: 1px solid #dfe3e6;
  background: #fff;
}

/* ── 分數格式 Inch 欄位 ── */
.frac {
  display: inline-flex;
  align-items: center;
  line-height: 1;
}

.frac sup {
  font-size: 0.78em;
  line-height: 1;
  vertical-align: 0.4em;
  font-feature-settings: 'sups' 1;
}

.frac sub {
  font-size: 0.65em;
  line-height: 1;
  vertical-align: -0.25em;
  font-feature-settings: 'subs' 1;
}

/* ── 法律聲明 ── */
.legal-note {
  margin: 2rem 0 1.5rem;
  color: #222;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.7;
  text-align: center;
}

/* ── 目錄下載按鈕（對齊 STERiGLIDE 樣式）── */
.catalogue-link {
  display: block;
  width: fit-content;
  min-width: 280px;
  margin: 0 auto;
  padding: 0.65rem 1.5rem;
  border: 2px solid transparent;
  border-radius: 999px;
  background:
    linear-gradient(#fff, #fff) padding-box,
    linear-gradient(90deg, #0071bb, #00b5ef) border-box;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  text-decoration: none;
}

.catalogue-link span {
  background: linear-gradient(90deg, #0071bb, #00b5ef);
  background-clip: text;
  color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.catalogue-link:hover,
.catalogue-link:focus-visible {
  background: linear-gradient(90deg, #0071bb, #00b5ef) border-box;
}

.catalogue-link:hover span,
.catalogue-link:focus-visible span {
  background: none;
  color: #fff;
  -webkit-text-fill-color: #fff;
}

@media (max-width: 768px) {
  .product-spec {
    padding: 3rem 0;
  }

  .spec-inner {
    width: calc(100% - 2rem);
  }

  .catalogue-link {
    min-width: 0;
    width: 100%;
  }
}
</style>
